export enum NodeGroupingMode {
  Text,
  Element,
  Block
}
